import {combineReducers} from '@reduxjs/toolkit';

import {dashboard2} from './dashboard';

export default combineReducers({
    dashboard2,
});
